import { Flex, SystemStyleObject } from '@chakra-ui/react';
import { ReactNode } from 'react';

export const DistributionWrapper = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SystemStyleObject;
}) => (
  <Flex
    direction="column"
    gap={6}
    padding={8}
    border="1px solid"
    borderColor="primary.100"
    backgroundColor="white"
    borderRadius="12px"
    height="100%"
    sx={sx}
  >
    {children}
  </Flex>
);
